<p-dialog
  [visible]="visible"
  [modal]="false"
  [blockScroll]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [showHeader]="false"
  [baseZIndex]="2000"
  [focusOnShow]="false"
  [transitionOptions]="restoreWithoutTransition ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="delete-group-dialog"
  [maskStyleClass]="closing ? 'delete-dialog-mask delete-dialog-mask--closing' : 'delete-dialog-mask'"
  appendTo="body"
  (visibleChange)="!$event && close()"
  (onHide)="onHidden()"
>
  <div class="delete-dialog-content">
    <div class="delete-dialog-header">
      <h3>{{ 'dialogs.deleteTitle' | translate: { target: 'dialogs.targets.group' | translate } }}</h3>
      <button type="button" class="delete-dialog-close" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <p class="delete-dialog-copy">
      {{ 'dialogs.deleteQuestion' | translate: { target: 'dialogs.targetsDefinite.group' | translate } }} "<span>{{ groupName }}</span>" ?
    </p>

    <p class="delete-dialog-copy">
      {{ 'dialogs.deletingAuto' | translate: { target: 'dialogs.targets.group' | translate } }}
    </p>

    <ul class="delete-dialog-list">
      <li>{{ 'dialogs.liCancelIncoming' | translate }}</li>
      <li>{{ 'dialogs.liDeleteActivities' | translate: { target: 'dialogs.targets.group' | translate } }}</li>
      <li>{{ 'dialogs.liDeleteSubgroups' | translate }}</li>
    </ul>

    <p class="delete-dialog-copy">
      {{ 'dialogs.movedTo' | translate: { target: 'dialogs.targets.group' | translate } }} <span class="delete-dialog-copy--bold">{{ 'dialogs.deletedItems' | translate }}</span>
    </p>

    <p class="delete-dialog-copy delete-dialog-copy--warning" style="color: #C73F3F !important; font-weight: 600;">
      {{ 'dialogs.cannotBeUndone' | translate }}
    </p>

    <label class="delete-confirm-row">
      <input type="checkbox" [ngModel]="confirmed" (ngModelChange)="onConfirmedChange($event)" />
      <span>{{ 'dialogs.understand' | translate }}</span>
    </label>

    <div class="delete-dialog-actions">
      <button type="button" class="delete-cancel-btn" (click)="close()">
        <span class="button-label-offset">{{ 'dialogs.cancel' | translate }}</span>
      </button>
      <button type="button" class="delete-confirm-btn" [disabled]="!confirmed" (click)="confirm()">
        <i class="pi pi-trash"></i>
        <span class="button-label-offset">{{ 'dialogs.deleteGroupBtn' | translate }}</span>
      </button>
    </div>
  </div>
</p-dialog>
